import { render, staticRenderFns } from "./StockreturnList.vue?vue&type=template&id=05d4c69e&scoped=true&style=height%3A%20100%25&"
import script from "./StockreturnList.vue?vue&type=script&lang=js&"
export * from "./StockreturnList.vue?vue&type=script&lang=js&"
import style0 from "./StockreturnList.vue?vue&type=style&index=0&id=05d4c69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4c69e",
  null
  
)

export default component.exports